import { defineMessages } from 'react-intl';

const messages = defineMessages({
  camHistory: {
    id: 'App.CamTab.CAMHistory.CAMHistory',
    defaultMessage: 'CAM History',
  },
  type: {
    id: 'App.CamTab.CAMHistory.Type',
    defaultMessage: 'Type',
  },
  completedOn: {
    id: 'App.CamTab.CAMHistory.completedOn',
    defaultMessage: 'Completed On',
  },
  completedBy: {
    id: 'App.CamTab.CAMHistory.CompletedBy',
    defaultMessage: 'Completed By',
  },
  amount: {
    id: 'App.CamTab.CAMHistory.Amount',
    defaultMessage: 'Amount',
  },
  report: {
    id: 'App.CamTab.CAMHistory.Report',
    defaultMessage: 'Report',
  },
  noHistory: {
    id: 'App.CamTab.CAMHistory.NoHistory',
    defaultMessage: 'No History',
  },
  show: {
    id: 'App.CamTab.CAMHistory.Show',
    defaultMessage: 'Show',
  },
  hide: {
    id: 'App.CamTab.CAMHistory.Hide',
    defaultMessage: 'Hide',
  },
});

export default messages;
